export default __webpack_public_path__ + "static/media/chevronBlue.34699ca2.svg";